import { Link } from "react-router-dom";
import { useBreadcrumb } from "./BreadcrumbContext";
import { brandConfig } from "config/brandConfig";

const { NDD } = brandConfig;

export default function Breadcrumb() {
  const { items } = useBreadcrumb();

  if (items.length === 0) return null;

  // 🔹 Données structurées SEO
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.label,
      ...(item.href ? { item: `${NDD}${item.href}` } : {}),
    })),
  };

  return (
    <>
      {/* SEO invisible */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(jsonLd),
        }}
      />

      {/* Breadcrumb visible */}
      <nav aria-label="Fil d’Ariane" className="breadcrumbs">
        <ol>
          {items.map((item, index) => {
            const isLast = index === items.length - 1;

            return (
              <li key={index}>
                {!isLast && item.href ? (
                  <Link to={item.href}>{item.label}</Link>
                ) : (
                  <span aria-current="page">{item.label}</span>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
}
